export default "__VITE_ASSET__AaJfhb61__"